import type { FC } from "react";
import { useEffect } from "react";
import React from "react";
import { Outlet, useLocation, useNavigation } from "react-router";
import AlertSnackbar from "@/components/AlertSnackbar";
import Loader from "@/components/Loader";
import { setCurrentRoute } from "@/features/currentRouteSlice";
import { setGlobalCurrentTime } from "@/features/globalStateSlice";
import { initExternalRouteSync } from "@/routerConfig";
import { initExternalBreadcrumbSync } from "@/routerConfig/externalWindowEventSync";
import { useAppDispatch } from "@/storeHooks";
/**
 * Provides Outlet for routing and dispatches store actions.
 */
const Root: FC = () => {
  const navigation = useNavigation();
  const dispatch = useAppDispatch();
  const location = useLocation();

  useEffect(() => {
    // Ensure this is the only instance running the timer
    // the set interval needs to be this way otherwise components will have multiple instances of the timer
    dispatch(setGlobalCurrentTime(new Date().getTime()));
    window._globalTimeInterval ??= setInterval(() => {
      dispatch(setGlobalCurrentTime(new Date().getTime()));
    }, 10000);

    return () => {
      if (window._globalTimeInterval) {
        clearInterval(window._globalTimeInterval);
        window._globalTimeInterval = undefined;
      }
    };
  }, [dispatch]);

  useEffect(() => {
    initExternalRouteSync(dispatch);
    initExternalBreadcrumbSync(dispatch);
  }, [dispatch]);

  useEffect(() => {
    dispatch(setCurrentRoute(location.pathname));
  }, [location, dispatch]);

  return (
    <main id="app-main">
      <AlertSnackbar />
      <Loader loading={navigation.state === "loading"} />
      <Outlet />
    </main>
  );
};

export default Root;
